export default __webpack_public_path__ + "static/media/gallery-wip-handle_10.658a32a3.jpg";